<template>
  <div class="modal-card" style="width: auto">
    <form method="post" @submit.prevent="onSend" novalidate>
      <header class="modal-card-head">
        <p class="modal-card-title is-centered">
          匯出進銷報表
        </p>
      </header>

      <section class="modal-card-body">
        <form-wrapper :validator="$v.form">
          <form-group name="month" label="日期範圍" label-position="on-border">
            <b-datepicker
              v-model="selectedDates"
              range
              placeholder="請選擇範圍"
              icon="calendar-today"
              inline
              trap-focus
              required
              @input="onSelectedDates"
            >
              <div class="buttons">
                <b-button
                  :label="$t('attributes.this_month')"
                  type="is-success"
                  size="is-small"
                  @click="onSelectThisMonth"
                />
                <b-button
                  :label="$t('attributes.last_month')"
                  type="is-info"
                  size="is-small"
                  @click="onSelectLastMonth"
                />
                <b-button
                  :label="$t('attributes.three_month')"
                  type="is-warning"
                  size="is-small"
                  @click="onSelectThreeMonth"
                />
              </div>
            </b-datepicker>
          </form-group>
        </form-wrapper>
      </section>

      <footer class="modal-card-foot">
        <b-button
          :loading="sending"
          class="is-fullwidth"
          @click="$parent.close()"
        >
          {{ $t('attributes.cancel') }}
        </b-button>
        <b-button
          :loading="sending"
          type="is-primary"
          class="is-fullwidth"
          native-type="submit"
        >
          匯出
        </b-button>
      </footer>
    </form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'ExportInvoicingForm',

  props: {
    sending: {
      type: Boolean
    }
  },
  data() {
    const today = this.$dayjs()
    const startDate = today.startOf('month').toDate()
    const endDate = today.toDate()

    return {
      selectedDates: [startDate, endDate],

      form: {
        startDate,
        endDate
      }
    }
  },
  validations() {
    return {
      form: {
        startDate: { required },
        endDate: { required }
      }
    }
  },
  methods: {
    onSelectedDates() {
      this.form.startDate = this.selectedDates[0]
      this.form.endDate = this.selectedDates[1]
    },
    onSelectThisMonth() {
      const today = this.$dayjs()
      this.selectMonth(today)
    },
    onSelectLastMonth() {
      const day = this.$dayjs()
        .startOf('month')
        .subtract(1, 'day')
      this.selectMonth(day)
    },
    onSelectThreeMonth() {
      const today = this.$dayjs()
      this.form.startDate = today
        .subtract(3, 'month')
        .startOf('month')
        .toDate()
      this.form.endDate = today.toDate()
      this.selectedDates = [this.form.startDate, this.form.endDate]
    },
    selectMonth(day) {
      this.form.startDate = day.startOf('month').toDate()
      this.form.endDate = day.endOf('month').toDate()
      this.selectedDates = [this.form.startDate, this.form.endDate]
    },

    onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form.startDate, this.form.endDate)
    }
  }
}
</script>
